export const cleanCode = (raw: string | undefined): string => {
  let result = removeAndParseInvalidLineBreak(raw);
  result = removeZeroWidthSpace(result);

  return result;
};

export const removeZeroWidthSpace = (raw: string | undefined): string => {
  if (!raw) return '';

  return raw.replace(/\u200b/g, '');
};

export const removeAndParseInvalidLineBreak = (
  raw: string | undefined
): string => {
  if (!raw) return '';

  const rg = RegExp(/\\n/g);
  const validLineBreak = '-validLN-';
  const toBeTested = '-toBeTestedLN-';
  let rawData = raw || '';
  rawData = rawData.replace(/^\\n$/gm, '');
  while (rg.exec(rawData) !== null) {
    try {
      rawData = rawData.replace(/\\n/, toBeTested);
      rawData = rawData.replace(/\\n/g, '(function forTesting(){})();');
      rawData = rawData.replace(toBeTested, '\\n');
      window.Function(`"use strict";${rawData}`);

      rawData = rawData.replace(/\\n/, validLineBreak);
    } catch (error) {
      rawData = rawData.replace(/\\n/, '\n');
      rg.lastIndex = rg.lastIndex - 1;
    } finally {
      rawData = rawData.replace(
        /\(function forTesting\(\)\{\}\)\(\);/g,
        '\\n'
      );
    }
  }

  const validCode = rawData.replace(RegExp(validLineBreak, 'g'), '\\n');

  return validCode;
};
